import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import useHotTopics from "../hooks/useHotTopics";
import "./HotTopics.css";

export function HotTopicsList() {
  const { items, updatedAt, loading, error } = useHotTopics();
  return (
    <>
      {loading && <p className="hot-topics-tip">載入中…</p>}
      {error && items.length === 0 && <p className="hot-topics-tip">暫時無法載入</p>}
      <ol className="hot-topics-list">
        {items.map((t, i) => (
          <li key={i}>
            <span className="hot-topics-rank">{i + 1}</span>
            <span>{t}</span>
          </li>
        ))}
      </ol>
      {updatedAt && (
        <p className="hot-topics-tip">
          更新於{" "}
          {new Date(updatedAt).toLocaleString("zh-TW", {
            month: "numeric",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </p>
      )}
    </>
  );
}

// 桌面端右側固定卡片
export default function HotTopics() {
  return (
    <Paper
      elevation={3}
      sx={{
        display: "none",
        // 斷點請改成和左側「支持本站運營」卡片一致；1760px 是兩側都不壓住 1200px 內容區的最小寬度
        "@media (min-width:1760px)": { display: "block" },
        position: "fixed",
        top: "calc(var(--template-frame-height, 0px) + 80px)",
        right: 20,
        width: 280,
        maxHeight: "calc(100vh - 120px)",
        overflowY: "auto",
        p: 2,
        borderRadius: 3,
        zIndex: (t) => t.zIndex.appBar - 1,
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        🔥 今日熱點
      </Typography>
      <HotTopicsList />
    </Paper>
  );
}